// extracted by mini-css-extract-plugin
export default {"icon":"WasteTypeIcon_icon__Hy1Ub"};